import { createSvgIcon } from '@mui/material';
import Styled from "./custom-styled-icon";

export const ActionArrow = Styled(
    createSvgIcon(
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                stroke="currentColor"
                fill='none'
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M14.8265 17.84C14.6998 17.84 14.5731 17.7933 14.4731 17.6933C14.2798 17.5 14.2798 17.18 14.4731 16.9866L17.8131 13.6466C18.0065 13.4533 18.3265 13.4533 18.5198 13.6466C18.7131 13.84 18.7131 14.16 18.5198 14.3533L15.1798 17.6933C15.0798 17.7866 14.9531 17.84 14.8265 17.84Z" fill="#292D32" />
            <path stroke="currentColor"
                fill='none'
                strokeLinecap="round"
                strokeLinejoin="round" d="M18.1673 14.4933H6.83398C6.56065 14.4933 6.33398 14.2667 6.33398 13.9933C6.33398 13.72 6.56065 13.4933 6.83398 13.4933H18.1673C18.4407 13.4933 18.6673 13.72 18.6673 13.9933C18.6673 14.2667 18.4407 14.4933 18.1673 14.4933Z" fill="#292D32" />
            <path stroke="currentColor"
                strokeLinecap="round"
                fill='none'
                strokeLinejoin="round" d="M6.83427 10.5067C6.7076 10.5067 6.58094 10.46 6.48094 10.36C6.2876 10.1667 6.2876 9.84667 6.48094 9.65333L9.82094 6.31333C10.0143 6.12 10.3343 6.12 10.5276 6.31333C10.7209 6.50667 10.7209 6.82667 10.5276 7.02L7.1876 10.36C7.09427 10.4533 6.96094 10.5067 6.83427 10.5067Z" fill="#292D32" />
            <path stroke="currentColor"
                strokeLinecap="round"
                fill='none'
                strokeLinejoin="round" d="M18.1673 10.5067H6.83398C6.56065 10.5067 6.33398 10.28 6.33398 10.0067C6.33398 9.73332 6.56065 9.50665 6.83398 9.50665H18.1673C18.4407 9.50665 18.6673 9.73332 18.6673 10.0067C18.6673 10.28 18.4407 10.5067 18.1673 10.5067Z" fill="#292D32" />
        </svg>
        ,
        "ActionArrow",
    ),
)

export default ActionArrow;
